import Validation, { emailValidation, requiredValidation } from 'vendor/zod/validationZod';
import getTranslation from 'helpers/translation/getTranslation';
import { object, string } from 'zod';

export const loginFormValidation = () => {
    const schema = object({
        email: requiredValidation.pipe(emailValidation),
        orderNumber: requiredValidation.pipe(string().max(10, getTranslation('validation', 'IS_INVALID')))
    });

    const loginOrderValidation = new Validation({
        form: '#order-login-form',
        schema
    });

    loginOrderValidation.initValidation();
};
